import React, { useState, useEffect } from 'react';
import { FaPlus, FaTrash } from 'react-icons/fa';
import { db } from '../../firebase/config';
import { collection, getDocs, addDoc, deleteDoc, doc, updateDoc, serverTimestamp } from 'firebase/firestore';

function TypeManagement() {
  const [types, setTypes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTypes();
  }, []);

  const fetchTypes = async () => {
    try {
      console.log('TypeManagement: Fetching types...');
      const typesRef = collection(db, 'types');
      const snapshot = await getDocs(typesRef);
      const typesList = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      console.log('TypeManagement: Types fetched:', typesList);
      setTypes(typesList);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching types:', error);
      setLoading(false);
    }
  };

  const handleAdd = async () => {
    try {
      console.log('TypeManagement: Adding new type...');
      const newType = {
        name: 'New Type',
        description: '',
        status: 'active',
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp()
      };
      
      const docRef = await addDoc(collection(db, 'types'), newType);
      const typeWithId = { ...newType, id: docRef.id };
      console.log('TypeManagement: Added new type:', typeWithId);
      setTypes([typeWithId, ...types]);
    } catch (error) {
      console.error('Error adding type:', error);
    }
  };

  const handleDelete = async (id) => {
    try {
      console.log('TypeManagement: Deleting type...');
      await deleteDoc(doc(db, 'types', id));
      console.log('TypeManagement: Type deleted:', id);
      setTypes(types.filter(type => type.id !== id));
    } catch (error) {
      console.error('Error deleting type:', error);
    }
  };

  const handleStatusToggle = async (typeId) => {
    try {
      console.log('TypeManagement: Toggling status...');
      const type = types.find(t => t.id === typeId);
      const newStatus = type.status === 'active' ? 'inactive' : 'active';
      
      await updateDoc(doc(db, 'types', typeId), { 
        status: newStatus,
        updatedAt: serverTimestamp()
      });
      console.log('TypeManagement: Status toggled:', newStatus);
      setTypes(types.map(type =>
        type.id === typeId
          ? { ...type, status: newStatus }
          : type
      ));
    } catch (error) {
      console.error('Error updating status:', error);
    }
  };

  const handleNameChange = async (typeId, newName) => {
    try {
      console.log('TypeManagement: Updating name...');
      await updateDoc(doc(db, 'types', typeId), { 
        name: newName,
        updatedAt: serverTimestamp()
      });
      console.log('TypeManagement: Name updated:', newName);
      setTypes(types.map(type =>
        type.id === typeId
          ? { ...type, name: newName }
          : type
      ));
    } catch (error) {
      console.error('Error updating name:', error);
    }
  };

  const handleDescriptionChange = async (typeId, newDescription) => {
    try {
      console.log('TypeManagement: Updating description...');
      await updateDoc(doc(db, 'types', typeId), { 
        description: newDescription,
        updatedAt: serverTimestamp()
      });
      console.log('TypeManagement: Description updated:', newDescription);
      setTypes(types.map(type =>
        type.id === typeId
          ? { ...type, description: newDescription }
          : type
      ));
    } catch (error) {
      console.error('Error updating description:', error);
    }
  };

  const handleNameEdit = (typeId, isEditing) => {
    setTypes(types.map(type =>
      type.id === typeId
        ? { ...type, isEditing }
        : type
    ));
  };

  return (
    <div className="data-container">
      <button className="add-btn" onClick={handleAdd}>
        <FaPlus /> Add Type
      </button>
      <table className="data-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Description</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {types.map(type => (
            <tr key={type.id}>
              <td>
                {type.isEditing ? (
                  <input
                    type="text"
                    value={type.name}
                    onChange={(e) => handleNameChange(type.id, e.target.value)}
                    onBlur={() => handleNameEdit(type.id, false)}
                    onKeyPress={(e) => {
                      if (e.key === 'Enter') {
                        handleNameEdit(type.id, false);
                      }
                    }}
                    autoFocus
                    className="name-input"
                  />
                ) : (
                  <span 
                    onClick={() => handleNameEdit(type.id, true)}
                    className="editable-name"
                  >
                    {type.name}
                  </span>
                )}
              </td>
              <td>
                <input
                  type="text"
                  value={type.description || ''}
                  onChange={(e) => handleDescriptionChange(type.id, e.target.value)}
                  className="description-input"
                  placeholder="Enter description"
                />
              </td>
              <td>
                <button 
                  className={`status-badge ${type.status}`}
                  onClick={() => handleStatusToggle(type.id)}
                >
                  {type.status}
                </button>
              </td>
              <td>
                <button className="delete-button" onClick={() => handleDelete(type.id)}>
                  <FaTrash />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default TypeManagement;
